import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';

import { SvgLoaderComponent } from 'app/components/ui-kit/images/svg-loader/svg-loader.component';
import { AuthService } from 'app/services/auth.service';

import { ThemeService } from 'app/services/theme.service';
import { NavUserWidgetComponent } from '../nav-user-widget/nav-user-widget.component';

@Component({
  selector: 'app-admin-nav',
  standalone: true,
  imports: [SvgLoaderComponent, CommonModule, NavUserWidgetComponent, RouterLink, RouterLinkActive],
  templateUrl: './admin-nav.component.html',
  styleUrl: './admin-nav.component.scss'
})
export class AdminNavComponent {

  constructor(public themeService: ThemeService, private authService: AuthService, private router: Router) {}

  onClickLogo(): void {
    this.router.navigate(['/admin/hq']);
  }

}
